module.exports = __webpack_public_path__ + "media/images/favicon-32x32-732666ed2a871a2b398f8e10bd13eb51.png";